import { RigidBody, Physics } from '@react-three/rapier'
import ShapeCubes from './ShapeCubes'
import ShapeTorusHull from './ShapeTorusHull'
import ShapeBall from './ShapeBall'
import ShapeFloor from './ShapeFloor'
import ShapeTorusTrimesh from './ShapeTorusTrimesh'
import ShapeTorusCustom from './ShapeTorusCustom'
import ShapeCubeJumping from './ShapeCubeJumping'
import ShapeBlender from './ShapeBlender'
import ShapeCubeSound from './ShapeCubeSound'
import ShapeCubeCollision from './ShapeCubeCollision'
import ShapeBurger from './ShapeBurger'
import ShapeWalls from './ShapeWalls'
import ShapeCubeStress from './ShapeCubeStress'
import Burgers from './ShapeBurgers'
import ShapeSpade from './ShapeSpade'
import ShapePlate from './ShapePlate'

export default function PhysicsA()
{

    return <>
        <Physics 
            // debug

            // gravity={[5,-10,0]}
        >
            {/* <ShapeBall /> */}
            {/* <ShapeCubes /> */}
            {/* <ShapeCubeJumping /> */}
            {/* <ShapeCubeSound /> */}
            {/* <ShapeCubeCollision /> */}
            {/* <ShapeTorusHull /> */}
            {/* <ShapeTorusTrimesh /> */} 
            {/* <ShapeTorusCustom /> */}
            {/* <ShapeBurger /> */}

            <ShapeFloor />
            <ShapeBlender />
            <ShapeWalls aY={6} height={0} />

            <ShapeWalls aY={50} height={25} />

            {/* <ShapeCubeStress /> */}
            <Burgers />
            <ShapeSpade />
            <ShapePlate />

        </Physics>
    </>
}